<template>
  <div>

    <v-card tile outlined>

      <v-container>

        <v-form v-disable-all="userCanEdit || userCanEditLlodio" v-model="formSolicitanteValid"
          @submit.prevent="onSubmit($event)">

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="itemSolicitante.nombre" :rules="nombreRules" label="Apellidos, Nombre*"
                  required></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="itemSolicitante.dni" :rules="dniRules" label="Dni*" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="itemSolicitante.codigoPostal" label="Código postal"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="itemSolicitante.email" :rules="emailRules" label="Email*" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="itemSolicitante.telefono" :rules="telefonoRules" label="Teléfono*"
                  required></v-text-field>
              </v-col>
            </v-row>
            <small>*Indica campo requerido</small>
          </v-card-text>

          <v-card-actions v-if="userCanEdit || userCanEditLlodio">
            <v-btn type="submit" color="primary" :loading="loading" text>
              Guardar
            </v-btn>
          </v-card-actions>

        </v-form>

        <template v-if="userCanEdit || userCanEditLlodio">

          <v-divider class="mb-6"></v-divider>

          <v-subheader>Acciones</v-subheader>

          <v-list subheader two-line flat :disabled="accionesDisabled">

            <v-list-item-group v-model="settings" multiple>
              <v-list-item @click="sendEmails">
                <template v-slot:default="{}">

                  <v-list-item-action>

                    <v-btn class="ma-2" color="primary" text dark :loading="loadingEmails">
                      <v-icon>mdi-email-send-outline</v-icon>
                    </v-btn>

                  </v-list-item-action>

                  <v-list-item-content>

                    <v-list-item-title>Notificación prematrícula</v-list-item-title>

                    <v-list-item-subtitle>Reenviar emails de "Confirmación de prematrícula" y "Acceso a la matrícula" al
                      solicitante.</v-list-item-subtitle>

                  </v-list-item-content>

                </template>

              </v-list-item>

            </v-list-item-group>

          </v-list>

        </template>

      </v-container>

    </v-card>

    <!-- popup de confirmación -->
    <confirm ref="confirm"></confirm>

  </div>
</template>

<script>
import { update, sendEmails } from '@/api/prematriculas.api'
import Confirm from '@/components/Confirm'

export default {
  name: 'SolicitanteForm',
  props: {

    item: {
      type: Object,
      required: true,
    },

    userCanEdit: {
      type: Boolean,
      required: true
    },

    userCanEditLlodio: {
      type: Boolean,
      required: true
    }

  },

  components: {
    Confirm
  },
  data: () => {
    return {
      itemSolicitante: null,
      formSolicitanteValid: false,
      loading: false,
      nombreRules: [
        v => !!v || 'El campo es obligatorio',
      ],
      dniRules: [
        v => !!v || 'El campo es obligatorio'
      ],
      emailRules: [
        v => !!v || 'El campo es obligatorio',
        v => /.+@.+\..+/.test(v) || 'Email novalido',
      ],
      telefonoRules: [
        v => !!v || 'El campo es obligatorio',
      ],
      // acciones
      settings: [],
      accionesDisabled: false,
      loadingEmails: false
    }
  },

  created() {
    this.itemSolicitante = Object.assign(this.item.tutor)
  },

  methods: {

    async onSubmit(event) {
      this.loading = true;
      // validacion y emit
      if (this.formSolicitanteValid) {
        let params = {
          persona: {
            id: this.itemSolicitante.id,
            nombre: this.itemSolicitante.nombre,
            email: this.itemSolicitante.email,
            dni: this.itemSolicitante.dni,
            codigoPostal: this.itemSolicitante.codigoPostal,
            telefono: this.itemSolicitante.telefono
          }
        }

        // actualizar datos de prematricula
        await update(this.item, params).then(response => {
          this.$emit('submitSolicitante', event, response)
        }).catch(error => {
          console.error(error)
        })

      }

      this.loading = false;


    },

    async sendEmails() {

      // activar loading de la acción y deshabilitar acciones
      this.accionesDisabled = true;
      this.loadingEmails = true;

      // conf. confirmacion
      let title = 'Notificación prematrícula'
      let subtitle = '¿Estás seguro?'
      let message = `Si aceptas, los correos electrónicos de la prematrícula se reenviarán al email del solicitante.`
      let message2 = null

      // confirmacion
      if (await this.$refs.confirm.open(
        title,
        subtitle,
        message,
        message2,
        {
          color: 'primary',
          width: 300
        })
      ) {
        // Si acepta, enviamos los emails.
        await sendEmails(this.item).then(response => {
          this.$emit('sendEmails', event, response)
        }).catch(error => {
          console.error(error)
          // ocurrio algun error, no tenemos response .... 
          // se crea con status 500 y el msg del error. 
          this.$emit('sendEmails', event, { status: 500, error })
        })
      }

      // desactivar loading de la acción y habilitar acciones
      this.accionesDisabled = false;
      this.loadingEmails = false;
    }

  }


}

</script>